'use strict';
import angular from 'angular';
import 'angular-resource';
import '../../modules/modals/modals.module';
import '../../modules/exceptionlogs/exceptionlogs.module';
import '../../modules/integrations/integrations.module';
import '../../modules/inventorycalendar/inventorycalendar.module';
import '../../modules/nightlystatus/nightlystatus.module';
import '../../modules/notifications/notifications.module';
import '../../modules/reporting/reporting.module';
import '../../modules/ioclients/ioclients.module';
import '../../modules/formlist/formlist.module';
import '../../modules/lookup/lookup.module';
import '../../modules/ratecard/ratecard.module';
import '../../modules/rulesets/rulesets.module';
import '../../modules/management/management.module';
import '../../modules/queues/queues.module';
import '../../modules/workflows/workflows.module';
import '../../modules/products/products.module';
import '../../modules/tasks/tasks.module';
import '../../modules/productCategories/productCategories.module';
import '../../modules/steps/steps.module';
import '../../modules/tieredLookups/tieredLookups.module';
import '../../modules/Packages/Packages.module';
import '../../modules/inOutStatus/inOutStatus.module';
import '../../modules/scheduledJobs/scheduledJobs.module';
import '../../modules/common/common.module';
import '../../modules/creatives/creatives.module';
import '../../modules/pixels/pixels.module';
import 'coreModules/lineitem/scripts/lineitems.directives';
import '../../modules/calendar/calendar.module';
import '../../modules/ioclusters/ioclusters.module';
import '../../modules/clientServiceMapping/clientServiceMapping.module';
import '../../modules/ioServiceConnections/ioServiceConnections.module';
import '../../modules/buySheetConfig/buySheetConfig.module';
import '../../modules/currentUser/currentUser.module';
import '../../modules/currentUser/scripts/currentUser.service';
import '../../modules/instanceSettings/instanceSettings.module';
import '../../modules/tasksFilter/tasksFilter.module';
import '../../modules/tasksFilter/tasksFilter.component';
import '../../modules/tasksFilter/tasksFilterDefaultOptionsProvider.service';
import '../../modules/tasksFilter/tasksFilterDetailedOrdersOptionsProvider.service';
import '../../modules/tasksFilter/tasksFilterOptionsProviderFactory.service';
import '../../modules/tasksFilter/tasksFilterTestOptionsProvider.service';
import '../../modules/vendor/vendors.module';
import '../views/shared/AccessRestrictedService';
import '../../modules/buySheet/buySheet.module'
import '../../modules/fieldTransformation/fieldTransformation.imports';
import '../../modules/publishToDashboards/publishToDashboards.imports';
import '../../modules/errorsHandler/errorsHandler.module';
import '../../modules/associationHistory/associationHistory.module';
import '../../modules/workflowclient/workflowclient.module';
import '../../modules/activityLog/activityLog.module';

angular.module('app.ctrls', ['currentUser']);

angular.module('app.directives', []);

angular.module('app.services', ['ngResource', 'currentUser']);

angular.module('app.filters', []);

//This is where we inject our IO "Components"
angular.module('app.modules', [
    'associationHistory',
    'activityLog',
    'buySheet',
    'buySheetConfig',
    'calendar',
    'clientServiceMapping',
    'common',
    'creativesLibrary',
    'pixelsManager',
    'currentUser',
    'errorsHandler',
    'exceptionlogs',
    'fieldTransformation',
    'forbidden',
    'formlist',
    'inOutStatus',
    'instanceSettings',
    'integrations',
    'inventorycalendar',
    'ioclients',
    'ioclusters',
    'ioServiceConnections',
    'lineitems.directives',
    'lookup',
    'management',
    'modals',
    'nightlystatus',
    'notifications',
    'productCategories',
    'products',
    'publishToDashboards',
    'queues',
    'ratecard',
    'reporting',
    'rulesets',
    'scheduledJobs',
    'steps',
    'tasks',
    'tasksFilter',
    'tieredLookups',
    'Packages',
    'vendors',
    'workflows',
    'workflowclient'
]);
